import React from 'react'
import CustomCalendar from '../components/CustomCalender'

const holidays = () => {
  return (
    <div>
      <CustomCalendar />
    </div>
  )
}

export default holidays
